import React from "react";
import App from "./../app.jsx";
import { Navigate } from "react-router-dom";

import WorkOrders from "./../pages/work-order/orders";
import Dashboard from "./../pages/dashboard/dashboard.js";
import PrivateRoute from "../lib/PrivateRoute.jsx";
import PagesLogin from "./../pages/pages/login.js";
import PagesLoginByPass from "./../pages/pages/login-bypass";
import Calendar from "./../pages/calendar/calendar.js";
import PublicRegister from "../pages/pages/public-register";
import AssetManagement from "../pages/assets/list.js";
import AssetAdd from "../pages/assets/add.js";
import PartManagement from "../pages/parts_inventory/list_part.js";
import InventoryManagement from "../pages/parts_inventory/inventory.js";
import CompanyConfiguration from "../pages/configurations/company";
import LocationConfiguration from "../pages/configurations/location";
import RolesConfiguration from "../pages/configurations/roles-cmms";
import UserConfiguration from "../pages/configurations/users";
import VendorList from "../pages/vendor/list";
import VendorAdd from "../pages/vendor/add";
import CustomerList from "../pages/customer/list";
import CustomerAdd from "../pages/customer/add";
import PartsAdd from "../pages/parts_inventory/add";
import AssetDetail from "../pages/assets/detail";
import WorkOrderAdd from "../pages/work-order/add";
import TeamConfiguration from "../pages/configurations/team";
import WorkOrderDetail from "../pages/work-order/detail.js";
import Checklist from "../pages/Checklist/list.js";
import AddChecklist from "../pages/Checklist/add.js";
import { PermissionChecker } from "../components/PermissionChecker/index.jsx";
import { PERMISSIONS } from "./app-permissions-cmms.js";
import ImportPage from "../pages/configurations/import/index.jsx";
import PageReset from "../pages/pages/reset.js";
import EmailActivate from "../pages/pages/email-activate";
import CategoryConfiguration from "../pages/configurations/category/index.jsx";
import PurchaseOrderList from "../pages/purchase_order/list.js";
import AddPurchaseOrder from "../pages/purchase_order/add.js";
import DetailPurchaseOrder from "../pages/purchase_order/detail.js";
import WorkOrderDetailRequest from "../pages/work-order/detail-request.js";
import SetupCenter from "../pages/setup-center";
import AnalyticsCMMS from "../pages/analytics_cmms/analytics";
import ROIPublic from "./../pages/pages/roi-public.js";
import PrintQRCode from "../pages/qrcode/index.jsx";
import QuotationList from "../pages/quotation/list.js";
import AddQuotation from "../pages/quotation/add.js";
import PublicRequest from "../pages/request/add";
import DetailQuotation from "../pages/quotation/detail.js";
import ChatAssistant from "../pages/ai/ChatAssistant.jsx";

import PublicRequestTracker from "../pages/request/tracking";
import WhatsappGateway from "../pages/configurations/whatsapp-gateway";
import { ChatAssistantIFrame } from "../pages/ai/ChatAssistantIFrame.jsx";
import Documents from "../pages/pages/documentation";
import DocumentsAiList from "../pages/ai-pdf/list";
import DocumentChat from "../pages/ai-pdf/chat";
import ServiceManagement from "../pages/service/services";
import ServiceAdd from "../pages/service/add";
import MeterList from "../pages/meters/list";
import MeterAdd from "../pages/meters/add";
import MeterDetail from "../pages/meters/detail";
import RequestPublicList from "../pages/request/list";
import MeterReadings from "../pages/meters/readings";
import CmmsReport from "../pages/cmms-report"
import PublicLinkGenerator from "../pages/request/public-link"
import IssueTrackingList from "../pages/issue-tracking/list";
import AddIssueTracking from "../pages/issue-tracking/add";
import IssueTrackingDetail from "../pages/issue-tracking/detail";
import ServiceGroupConfiguration from "../pages/configurations/service-group";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Navigate to="/work-order/list" />
          </PrivateRoute>
        ),
      },
      { path: "login", element: <PagesLogin /> },
      { path: "chat-assistant", element: <ChatAssistantIFrame /> },
      { path: "login-by-pass/*", element: <PagesLoginByPass /> },
      { path: "public-request/:token", element: <PublicRequest /> },
      { path: "set-request/:token", element: <RequestPublicList /> },
      { path: "tracking-request/:id", element: <PublicRequestTracker /> },
      { path: "public-register", element: <PublicRegister /> },
      { path: "roi-calculator", element: <ROIPublic /> },
      { path: "password/*", element: <PageReset /> },
      { path: "account/*", element: <EmailActivate /> },
      {
        path: "setup-center",
        element: (
          <PrivateRoute>
            <PermissionChecker permissions={["view setup center"]}>
              <SetupCenter />
            </PermissionChecker>
          </PrivateRoute>
        ),
      },
      {
        path: "analytics",
        element: (
          <PrivateRoute>
            <PermissionChecker permissions={["view analytic"]}>
              <AnalyticsCMMS />
            </PermissionChecker>
          </PrivateRoute>
        ),
      },

      {
        path: "report-generator",
        element: (
          <PrivateRoute>
            <PermissionChecker permissions={["create report"]}>
              <CmmsReport />
            </PermissionChecker>
          </PrivateRoute>
        ),
      },
      {
        path: "checklist/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view checklist"]}>
                  <Checklist />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create checklist"]}>
                  <AddChecklist />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker
                  permissions={["view checklist", "edit checklist"]}
                >
                  <AddChecklist />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "work-order/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view work order"]}>
                  <WorkOrders key="work-order-list" />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create work order"]}>
                  <WorkOrderAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit work order"]}>
                  <WorkOrderAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view work order"]}>
                  <WorkOrderDetail />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "issue-tracking/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view issue tracking"]}>
                  <IssueTrackingList />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create issue tracking"]}>
                  <AddIssueTracking />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit issue tracking"]}>
                  <AddIssueTracking />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view issue tracking"]}>
                  <IssueTrackingDetail />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "request/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view request"]}>
                  <WorkOrders isRequest key="request-list" />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "public-link",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create request"]}>
                  <PublicLinkGenerator />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create request"]}>
                  <WorkOrderAdd isRequest />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit request"]}>
                  <WorkOrderAdd isRequest />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view request"]}>
                  <WorkOrderDetailRequest />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "assets/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view asset"]}>
                  <AssetManagement />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create asset"]}>
                  <AssetAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit asset"]}>
                  <AssetAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view asset"]}>
                  <AssetDetail />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "document/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create document"]}>
                  <DocumentsAiList />{" "}
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "doc-chat",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view pdf ai"]}>
                  <DocumentChat />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "video",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create document"]}>
                  <Documents />{" "}
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "vendor/*",
        children: [
          {
            path: "management",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view vendor"]}>
                  <VendorList />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create vendor"]}>
                  <VendorAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view vendor", "edit vendor"]}>
                  <VendorAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "customer/*",
        children: [
          {
            path: "management",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view customer"]}>
                  <CustomerList />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create customer"]}>
                  <CustomerAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker
                  permissions={["view customer", "edit customer"]}
                >
                  <CustomerAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "part/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view part"]}>
                  <PartManagement />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "inventory",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view inventory"]}>
                  <InventoryManagement />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create part"]}>
                  <PartsAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view part", "edit part"]}>
                  <PartsAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "purchase-order/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view purchase order"]}>
                  <PurchaseOrderList />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },

          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create purchase order"]}>
                  <AddPurchaseOrder />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit purchase order"]}>
                  <AddPurchaseOrder />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "duplicate/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create purchase order"]}>
                  <AddPurchaseOrder duplicate={true} />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view purchase order"]}>
                  <DetailPurchaseOrder />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "quotation/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view quotation"]}>
                  <QuotationList />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },

          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create quotation"]}>
                  <AddQuotation />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit quotation"]}>
                  <AddQuotation />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "duplicate/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create quotation"]}>
                  <AddQuotation duplicate={true} />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view quotation"]}>
                  <DetailQuotation />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "inventory/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view inventory"]}>
                  <InventoryManagement />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "setup/*",
        children: [
          {
            path: "company",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view company profile"]}>
                  <CompanyConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "whatsapp-gateway",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view whatsapp"]}>
                  <WhatsappGateway />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "location",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view location"]}>
                  <LocationConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "service-group",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view service group"]}>
                  <ServiceGroupConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "category",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view category"]}>
                  <CategoryConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "roles",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view role"]}>
                  <RolesConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "users",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view people"]}>
                  <UserConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "workers/*",
        children: [
          {
            path: "people",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view people"]}>
                  <UserConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "teams",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view team"]}>
                  <TeamConfiguration />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "import",
        element: (
          <PrivateRoute>
            <PermissionChecker permissions={["view import"]}>
              <ImportPage />
            </PermissionChecker>
          </PrivateRoute>
        ),
      },
      {
        path: "qrcode",
        element: (
          <PrivateRoute>
            <PrintQRCode />
          </PrivateRoute>
        ),
      },

      {
        path: "service/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view service"]}>
                  <ServiceManagement />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create service"]}>
                  <ServiceAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker
                  permissions={["view service", "edit service"]}
                >
                  <ServiceAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "meter/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view meter reading"]}>
                  <MeterList />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["create meter reading"]}>
                  <MeterAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["edit meter reading"]}>
                  <MeterAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view meter reading"]}>
                  <MeterDetail />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "readings/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={["view meter reading"]}>
                  <MeterReadings />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
        ],
      },
    ],
  },
];

export default AppRoute;
